import React, { useState } from "react";
import { HashRouter as Router, Routes, Route, useLocation } from "react-router-dom";

import Menu from "./Menu";
import Footer from "./Footer";
import AdminLogin from "./AdminLogin";
import AdminDashboard from "./AdminDashboard";

import About from "./pages/About";
import Pricing from "./pages/Pricing";
import Contact from "./pages/Contact";
import Account from "./pages/Account";
import ChangePassword from "./pages/ChangePassword";
import Terms from "./pages/Terms";
import Privacy from "./pages/Privacy";
import Disclaimer from "./pages/Disclaimer";

import JobOptions from "./JobOptions";
import TemplateSelector from "./TemplateSelector";
import ResumeForm from "./ResumeForm";
import ResumePreview from "./ResumePreview";
import LoginForm from "./LoginForm";
import RegisterForm from "./RegisterForm";
import PayPalCheckout from "./PayPalCheckout";

function AppContent({
  user,
  setUser,
  jobType,
  setJobType,
  template,
  setTemplate,
  resumeData,
  setResumeData,
  authMode,
  setAuthMode,
}) {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith("/admin");

  const handleLogin = (userData) => {
    setUser(userData);
    if (template) {
      window.location.hash = "#/payment";
    } else {
      alert("Please select a template before proceeding to payment.");
      window.location.hash = "#/templates";
    }
  };

  const handleRegister = (userData) => {
    setUser(userData);
    if (template) {
      window.location.hash = "#/payment";
    } else {
      alert("Please select a template before proceeding to payment.");
      window.location.hash = "#/templates";
    }
  };

  const handlePaymentSuccess = () => {
   // alert("✅ Payment successful!");
    window.location.hash = "#/account";
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
      {!isAdminRoute && <Menu />}

      <div style={{ flex: 1 }}>
        <Routes>
          {/* Resume Builder Routes */}
          <Route
            path="/job"
            element={
              <JobOptions
                onSelectJob={(job) => {
                  setJobType(job);
                  window.location.hash = "#/templates";
                }}
              />
            }
          />
          <Route
            path="/templates"
            element={
              <TemplateSelector
                jobType={jobType}
                onSelectTemplate={(tpl) => {
                  setTemplate(tpl);
                  window.location.hash = "#/form";
                }}
              />
            }
          />
          <Route
            path="/form"
            element={
              <div class="res-txt">
                <ResumeForm
                  resumeData={resumeData}
                  setResumeData={setResumeData}
                  onProceed={() => {
                    if (template) {
                      window.location.hash = "#/payment";
                    } else {
                      alert("Please select a template first.");
                      window.location.hash = "#/templates";
                    }
                  }}
                />
                <ResumePreview resumeData={resumeData} template={template} style={{ flex: 1 }} />
              </div>
            }
          />
          <Route
            path="/auth"
            element={
              authMode === "login" ? (
                <LoginForm
                  onLogin={handleLogin}
                  onGoToRegister={() => setAuthMode("register")}
                />
              ) : (
                <RegisterForm
                  onRegister={handleRegister}
                  onGoToLogin={() => setAuthMode("login")}
                />
              )
            }
          />
          <Route
            path="/payment"
            element={
              user ? (
                <div class="payment-sec">
                  <ResumePreview resumeData={resumeData} template={template} style={{ flex: 1 }} />
                  <PayPalCheckout
                    onSuccess={handlePaymentSuccess}
                    userEmail={user.email} // ✅ Pass user email here
                  />
                </div>
              ) : authMode === "login" ? (
                <LoginForm
                  onLogin={handleLogin}
                  onGoToRegister={() => setAuthMode("register")}
                />
              ) : (
                <RegisterForm
                  onRegister={handleRegister}
                  onGoToLogin={() => setAuthMode("login")}
                />
              )
            }
          />

          {/* Public Routes */}
          <Route
            path="/"
            element={
              <JobOptions
                onSelectJob={(job) => {
                  setJobType(job);
                  window.location.hash = "#/templates";
                }}
              />
            }
          />
          <Route path="/about" element={<About />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/account" element={<Account user={user} setUser={setUser} />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/disclaimer" element={<Disclaimer />} />

          {user && <Route path="/change-password" element={<ChangePassword user={user} />} />}
          
          {/* Admin Routes */}
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
        </Routes>
      </div>

      {!isAdminRoute && <Footer />}
    </div>
  );
}

function App() {
  const [user, setUser] = useState(null);
  const [jobType, setJobType] = useState(null);
  const [template, setTemplate] = useState(null);
  const [resumeData, setResumeData] = useState({});
  const [authMode, setAuthMode] = useState("login");

  return (
    <Router>
      <AppContent
        user={user}
        setUser={setUser}
        jobType={jobType}
        setJobType={setJobType}
        template={template}
        setTemplate={setTemplate}
        resumeData={resumeData}
        setResumeData={setResumeData}
        authMode={authMode}
        setAuthMode={setAuthMode}
      />
    </Router>
  );
}

export default App;
